import { useEffect, useRef } from 'react';
import twemoji from '@twemoji/api';

export const useTwemoji = () => {
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    if (ref.current) {
      twemoji.parse(ref.current, {
        folder: 'svg',
        ext: '.svg',
      });
    }
  }, []);

  return ref;
};
